import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

export const updatePersonalInformation = async (data) => {
    try {
        const response = await apiClient.patch(
            API_ENDPOINTS.SETTINGS.UPDATE_PERSONAL_INFORMATION,
            data
        );

        return response.data;
    } catch (error) {
        console.error("Error updating personal information:", error);
        throw error;
    }
};

export const updateEmail = async (data) => {
    try {
        const response = await apiClient.patch(
            API_ENDPOINTS.SETTINGS.UPDATE_EMAIL,
            data
        );

        return response.data;
    } catch (error) {
        console.error("Error updating email:", error);
        throw error;
    }
};

export const updatePassword = async (data) => {
    try {
        const response = await apiClient.patch(
            API_ENDPOINTS.SETTINGS.UPDATE_PASSWORD,
            data
        );

        return response.data;
    } catch (error) {
        console.error("Error updating password:", error);
        throw error;
    }
};